// these match the graph
enum SummaryType {
  COMMENTS = "comments",
  RECOGNITIONS = "recognitions",
  TROPHIES = "trophies"
}

export default SummaryType
